module.exports = "/_next/static/files/32e4fa6eeac4b966a19a48fe04633f5e.png";